import styled from "styled-components";

export const FooterCountryWrapper = styled.div`
width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  
  @media (min-width: 428px){
    gap: 20px;
    width: auto;
    flex-direction: row;
    justify-items: flex-end;
  } 

  @media (min-width: 744px){
    gap: 20px;
  } 
`;

export const FooterCountryContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: ${(props) => props.width ? props.width :  "150px"};
  height: 40px;
  background: #021f36;
  border-radius: 7px;

  @media (min-width: 744px){
    width: 127px;
  } 
`;

export const FooterCountrySelectionContainer = styled(FooterCountryContainer)`
  width: 186px;

  @media (min-width: 744px){
    width: 181px;
  }
`

export const FooterCountryLogo = styled.img`
  width: ${(props) => (props.width ? props.width : "20px")};
  height: ${(props) => (props.width ? props.height : "12px")};
  src: ${(props) => props.src};
`;

export const FooterCountryText = styled.div`
  font-size: 14px;

`;
export const FooterSelectCountryText = styled.span`
  color: ${(props) => (props.color ? props.color : "#9EA9B9")};
`;
